const LIST_NAME = 'DISCOUNT_HISTORY_LIST'
const GET_YEARS = `${LIST_NAME}_GET_YEARS`

export default {
  LIST_NAME,
  GET_YEARS
}
